import { Reveal, Chapter } from "@/components/Reveal";

const PILLARS = [
  {
    n: "I",
    title: "People",
    copy: "Finding exceptional individuals who fit the culture and vision.",
  },
  {
    n: "II",
    title: "Passion",
    copy: "Connecting hospitality professionals who genuinely believe in service excellence.",
  },
  {
    n: "III",
    title: "Performance",
    copy: "Building teams capable of delivering commercial results and memorable guest experiences.",
  },
];

const Philosophy = () => (
  <section data-testid="philosophy-section" className="bg-ivory py-28 lg:py-40 hairline">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <Reveal>
        <Chapter number="01" label="The Core Philosophy" />
      </Reveal>
      <Reveal delay={0.1}>
        <blockquote className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.2] text-ink max-w-4xl">
          “Recruitment should never simply be about filling vacancies. It should be about
          understanding <span className="italic text-bronze">the identity of the brand</span>, the
          expectations of the guest and the leadership required to create sustainable performance.”
        </blockquote>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-8 text-sm text-ink/50 max-w-xl leading-relaxed">
          We create strategic frameworks that align exceptional human capital with ambitious
          hospitality concepts worldwide.
        </p>
      </Reveal>

      <div className="mt-20 lg:mt-28 grid md:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={0.1 + i * 0.12} className="bg-ivory">
            <div
              data-testid={`pillar-${p.title.toLowerCase()}`}
              className="group p-10 lg:p-14 h-full hover:bg-sand/60 transition-colors duration-700"
            >
              <span className="font-serif italic text-bronze text-lg">{p.n}</span>
              <h3 className="font-serif text-3xl lg:text-4xl font-light text-ink mt-6 tracking-wide">
                {p.title.toUpperCase()}
              </h3>
              <p className="mt-5 text-sm text-ink/60 leading-relaxed">{p.copy}</p>
              <span className="block mt-8 h-px w-0 bg-bronze group-hover:w-full transition-all duration-700" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Philosophy;
